import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=815fbab4&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=ts"
export * from "./PreviewImg.vue?vue&type=script&lang=ts"
import style0 from "./PreviewImg.vue?vue&type=style&index=0&id=815fbab4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815fbab4",
  null
  
)

export default component.exports